import React, { createContext, useState } from "react";

export const CartContextStart = createContext();

export default function CartContext(props) {
  const [cartItems, setCartItems] = useState([]);

  return (
    <CartContextStart.Provider value={{ cartItems, setCartItems }}>
      {props.children}
    </CartContextStart.Provider>
  );
}
